/**
 * Missing documents are stored as a JSON-encoded array string (the field is a
 * Multi Select picklist); older rows may hold plain text. Either way callers
 * get the individual document names, or [] when nothing is recorded.
 */
export function missingDocumentsItems(value: unknown): string[] {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((item) => typeof item === 'string')) {
      return parsed.map((item) => item.trim()).filter(Boolean);
    }
  } catch {
    // Plain-text legacy value — treat the whole string as one document.
  }
  return [raw];
}

/** The documents as one comma-separated string, or '' when none. */
export function missingDocumentsList(value: unknown): string {
  return missingDocumentsItems(value).join(', ');
}
